module.exports = __webpack_public_path__ + "img/adab7da.svg";